import { partes, type Bloco } from "@nhomi/conteudo";

/* ============================================================
   Desenha os textos longos do `@nhomi/conteudo`

   A política de privacidade e o "sobre" são os mesmos nos dois lados —
   têm que ser, porque a ficha da loja aponta para a URL do site e a
   pessoa lê a do app. Antes eles eram dois textos, escritos em dois
   formatos, e o do app já tinha perdido todos os negritos no caminho.

   Aqui o que muda em relação ao JSX que existia antes é só ONDE as
   palavras moram. As marcas de `<h2>`, `<p>` e `<p class="fine">`
   continuam sendo as mesmas, e o `<strong>` volta pelo `**` da
   marcação.
   ============================================================ */

export function TextoLongo({ blocos }: { blocos: Bloco[] }) {
  return (
    <>
      {blocos.map((b, i) => {
        const dentro = partes(b.txt).map((parte, j) => {
          if (parte.url) return <a key={j} href={parte.url}>{parte.txt}</a>;
          if (parte.forte) return <strong key={j}>{parte.txt}</strong>;
          return <span key={j}>{parte.txt}</span>;
        });
        if (b.tipo === "titulo") return <h2 key={i}>{dentro}</h2>;
        if (b.tipo === "fina") return <p key={i} className="fine">{dentro}</p>;
        return <p key={i}>{dentro}</p>;
      })}
    </>
  );
}
